import ParcelasGerenciadasDto from '@/models/dto/ParcelasGerenciadasDto';

class ParcelasGerenciadasResource {
  primeiraParcela: boolean;
  demaisParcelas: boolean;

  constructor(dto?: ParcelasGerenciadasDto | null) {
    this.primeiraParcela = dto?.primeiraParcela ?? true;
    this.demaisParcelas = dto?.demaisParcelas ?? true;
  }
}

export default ParcelasGerenciadasResource;
